export interface Vertical {
  code: string
  label: string
  description: string
  icon: string
  status: 'live' | 'coming_soon'
  defaultModules: string[]
}

export const VERTICALS: Vertical[] = [
  {
    code: 'retail',
    label: 'Trading / Retail',
    description: 'POS, sales, inventory, purchases',
    icon: 'ShoppingBag',
    status: 'live',
    defaultModules: ['core', 'retail'],
  },
  {
    code: 'restaurant',
    label: 'Restaurant / F&B',
    description: 'Table orders, menu, kitchen',
    icon: 'UtensilsCrossed',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'school',
    label: 'School Management',
    description: 'Students, fees, attendance, grades',
    icon: 'GraduationCap',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'hotel',
    label: 'Hotel / Hospitality',
    description: 'Rooms, bookings, guests',
    icon: 'Hotel',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'logistics',
    label: 'Logistics',
    description: 'Shipments, fleet, tracking',
    icon: 'Truck',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'healthcare',
    label: 'Healthcare',
    description: 'Patients, appointments, billing',
    icon: 'Stethoscope',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'real_estate',
    label: 'Real Estate',
    description: 'Properties, tenants, leases',
    icon: 'Building2',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'manufacturing',
    label: 'Manufacturing',
    description: 'BOM, production, work orders',
    icon: 'Factory',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'cooperative',
    label: 'Cooperative Society',
    description: 'Members, contributions, loans',
    icon: 'Users2',
    status: 'coming_soon',
    defaultModules: [],
  },
  {
    code: 'professional',
    label: 'Professional Services',
    description: 'Time tracking, projects, retainers',
    icon: 'Briefcase',
    status: 'coming_soon',
    defaultModules: [],
  },
]

export const ACTIVE_VERTICALS = VERTICALS.filter(v => v.status === 'live')
export const COMING_SOON_VERTICALS = VERTICALS.filter(v => v.status === 'coming_soon')

// Non-Retail verticals are being built as SEPARATE products (e.g. Palstro-Hotels
// in its own repo), so their "Coming Soon" placeholder tiles are hidden inside
// Palstro. Flip to `true` to restore all coming-soon tiles/nav across the app.
// Consumers: VerticalPickerStep (onboarding), Sidebar (Other Modules section).
export const SHOW_COMING_SOON_VERTICALS = false
export const VISIBLE_VERTICALS = SHOW_COMING_SOON_VERTICALS ? VERTICALS : ACTIVE_VERTICALS

export function getVerticalByCode(code: string): Vertical | undefined {
  return VERTICALS.find(v => v.code === code)
}
